import { ReactElement } from 'react'
import Layout from '../../components/layout'
import CustomerOrderList from '../../components/Users/orders'

const CustomerOrderPage = (): ReactElement => {
  return (
    <Layout >
      <CustomerOrderList />
    </Layout>
  )
}

export default CustomerOrderPage
